import React, {Component} from 'react';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TandCComponent from '../TandCComponent/TandCComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import InitialCredentialsComponent from '../InitialCredentialsComponent/InitialCredentialsComponent';

class InitialPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            errorTitle: ''
        };
        this.handleError = this.handleError.bind(this);
        this.clearAlert = this.clearAlert.bind(this);
    }

    clearAlert() {
        this.setState({error: '', errorTitle: ''});
    }

    handleError(error) {
        this.setState({error});
    }

    render() {
        let options = {'siteName': this.props.siteName};
        let cardContent = (
            <InitialCredentialsComponent
                actionLocation={this.props.actionLocation}
                lingua={this.props.lingua}
                firstName={this.props.firstName}
                currentPage={this.props.currentPage}
                performInitialBulkUpdate={this.props.performInitialBulkUpdate}
                setAuthAccountType={this.props.setAuthAccountType}
                handleError = {this.handleError}
                locale = {this.props.locale}
                onClose={this.props.onClose}
                isWaiting={this.props.isWaiting}
                enableLoading={this.props.enableLoading}
                disableLoading={this.props.disableLoading}
                site={this.props.site}
                handleLoginSuccess={this.props.handleLoginSuccess}
                updatePage={this.props.updatePage}
                performBulkPageUpdate={this.props.performBulkPageUpdate}
                setAuthJson={this.props.setAuthJson}
                multiUserEnabled={this.props.multiUserEnabled}
                expediaIconDisplayed={this.props.expediaIconDisplayed}
            />
        );
        return (
            <div className="InitialPageComponent border-border-color">
                <HeaderSectionComponent header={this.props.lingua.read('lex.header.initial', options)}/>
                <CalloutCardComponent content = {cardContent} error={this.state.error} errorTitle={this.state.errorTitle} clearAlert={this.clearAlert}/>
                <TandCComponent lingua={this.props.lingua} multiUserEnabled={this.props.multiUserEnabled}/>
            </div>
        );
    }
}

export default InitialPageComponent;
